import dumpPipelineApi from './DumpPipelineAxios';

function normalizeJobId(jobId) {
    if (!jobId) return '';
    if (typeof jobId === 'string') return jobId;
    if (typeof jobId === 'object') {
        if (jobId.$oid) return String(jobId.$oid);
        if (jobId._id) return normalizeJobId(jobId._id);
        if (jobId.id) return normalizeJobId(jobId.id);
    }
    return String(jobId);
}

function normalizeJob(job) {
    if (!job) return null;

    const status = String(job?.status || 'unknown');
    const total = Number(job?.total ?? 0);
    const processed = Number(job?.processed ?? job?.processados ?? 0);
    const progress = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;
    const id = normalizeJobId(job?.id || job?._id || '');

    return {
        ...job,
        id,
        jobId: id,
        status,
        total,
        processed,
        processados: processed,
        progress,
        selectedExperimentIds: Array.isArray(job?.selectedExperimentIds)
            ? job.selectedExperimentIds
            : [],
    };
}

export async function startTrainingJob(payload = {}) {
    const { data } = await dumpPipelineApi.post('/training/jobs', payload);
    return data;
}

export async function listTrainingJobs() {
    const { data } = await dumpPipelineApi.get('/training/jobs');
    return Array.isArray(data) ? data.map(normalizeJob) : [];
}

export async function getTrainingJob(jobId) {
    const normalized = normalizeJobId(jobId);
    if (!normalized) throw new Error('jobId é obrigatório');
    const { data } = await dumpPipelineApi.get(`/training/jobs/${encodeURIComponent(normalized)}`);
    if (Array.isArray(data)) {
        throw new Error('Resposta invalida em /training/jobs/{jobId}; backend desatualizado.');
    }
    return normalizeJob(data);
}

export async function getTrainingJobResult(jobId) {
    const normalized = normalizeJobId(jobId);
    if (!normalized) throw new Error('jobId é obrigatório');
    const { data } = await dumpPipelineApi.get(`/training/jobs/${encodeURIComponent(normalized)}/result`);
    if (Array.isArray(data)) {
        throw new Error('Resposta invalida em /training/jobs/{jobId}/result; backend desatualizado.');
    }
    return data;
}

export async function deleteTrainingJob(jobId) {
    const normalized = normalizeJobId(jobId);
    if (!normalized) throw new Error('jobId é obrigatório');
    const { data } = await dumpPipelineApi.delete(`/training/jobs/${encodeURIComponent(normalized)}`);
    return data;
}
